import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import Typography, { typography } from '@repo/ui/typography'
import { useFormContext } from 'react-hook-form'

import { EnrollmentInput } from '../../../../lib/types/models/enrollment/enrollment-input'
import { FormControl, FormField, FormItem } from '../../../elements/forms/form'
import ControlledInput from '../../../elements/inputs/controlled-input'

// where LEC adds its own details, next to the main health field written by the parent
const EnrollmentAdditionalMedicalInformationFields = () => {
  const form = useFormContext<EnrollmentInput>()
  const additionalMedicalInformations = form.watch('additionalMedicalInformations')

  return (
    <div className="flex flex-col gap-2">
      <Typography variant="label-medium">Information complémentaire</Typography>
      <FormField
        control={form.control}
        name="additionalMedicalInformations"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <ControlledInput
                {...field}
                type="textarea"
                label="Information complémentaire"
                value={field.value}
                onChange={(value) => {
                  field.onChange(value)
                  // the hidden translation must not be saved without the information it translates
                  if (typeof value !== 'string' || !value.trim())
                    form.setValue('additionalMedicalInformationsEn', undefined)
                }}
              />
            </FormControl>
          </FormItem>
        )}
      />
      {additionalMedicalInformations?.trim() && (
        <FormField
          control={form.control}
          name="additionalMedicalInformationsEn"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <ControlledInput
                  {...field}
                  type="textarea"
                  label="Traduction"
                  value={field.value}
                  style={{
                    ...typography['small-medium'],
                    color: tailwindColors.grey.light.active
                  }}
                />
              </FormControl>
            </FormItem>
          )}
        />
      )}
    </div>
  )
}

export default EnrollmentAdditionalMedicalInformationFields
